// Vue
import { RouteConfig } from 'vue-router'

// Clients
import { NonScHomeClient } from '../../clients/BackendAdminClient/nonsc-home'
import { NonScProjectClient } from '../../clients/BackendAdminClient/nonsc-project'
import { NonScProjectImageClient } from '../../clients/BackendAdminClient/nonsc-project-image'
import { NonScUserClient } from '../../clients/BackendAdminClient/nonsc-user'
import { NonScUserRoleClient } from '../../clients/BackendAdminClient/nonsc-user-role'
import { ProjectAddressClient } from '../../clients/BackendAdminClient/project-address'

// Routes
import routes from './routes'

export class NonScFeature {

  /** @type {RouteConfig} */
  static routes = routes

  // Client Address
  static address = ProjectAddressClient

  // Client Project
  static project = NonScProjectClient

  // Client Project Image
  static image = NonScProjectImageClient

  // Client Home
  static home = NonScHomeClient

  // Client User
  static user = NonScUserClient

  // Client User Role
  static role = NonScUserRoleClient
}



// WEBPACK FOOTER //
// ./src/features/nonsc/feature.js